var _style, _polygon, _polygon2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyboardAlarmKeypad({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#231F20;stroke-width:0.25;stroke-miterlimit:10;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "15.3,15.4 0.5,0.7 0.5,15.4 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "0.7,0.5 15.5,15.2 15.5,0.5 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M15.5,0.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardAlarmKeypad);
export default __webpack_public_path__ + "static/media/KeyboardAlarmKeypad.2c4d118bac09772ef2cdf59bed03e82c.svg";
export { ForwardRef as ReactComponent };